const STATUS_STYLES: Record<string, { label: string; className: string; hint: string }> = {
  uploaded: {
    label: "Uploaded",
    className: "bg-muted text-muted-foreground",
    hint: "Waiting for you to start annotation",
  },
  queued: {
    label: "Queued",
    className: "bg-secondary text-secondary-foreground",
    hint: "Waiting its turn",
  },
  annotating: {
    label: "Annotating",
    className: "bg-primary/12 text-primary",
    hint: "Being matched against databases",
  },
  ready: {
    label: "Ready",
    className: "bg-success/15 text-success-foreground",
    hint: "Your annotated file is ready",
  },
  failed: {
    label: "Failed",
    className: "bg-destructive/12 text-destructive",
    hint: "Something went wrong",
  },
};

export function StatusPill({ status }: { status: string }) {
  const style = STATUS_STYLES[status] ?? STATUS_STYLES["queued"]!;
  return (
    <span
      title={style.hint}
      className={`inline-flex items-center gap-2 rounded-full px-3 py-1 text-xs font-semibold ${style.className}`}
    >
      <span className="size-1.5 rounded-full bg-current" />
      {style.label}
    </span>
  );
}
